import { useTranslation } from 'react-i18next';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { BsFillCaretDownFill } from 'react-icons/bs';
import { MultiSelect, Option } from 'react-multi-select-component';
import { queryParams } from 'utils/query';
import { useAppContext } from 'context/hooks';
import classes from 'global.module.css';
import { Box } from '@mantine/core';

interface Props {
  queryKey: string;
}

export const FilterGroups = ({ queryKey }: Props) => {
  const { t } = useTranslation();
  const { parameters: filters, setParameters } = useSearchParameters(queryKey);
  const { currentUser } = useAppContext();

  const listData = currentUser?.visibleGroups.map((group) => ({ value: group.id, label: group.name })) || [];

  const filteredGroups = filters.groups
    ? listData.filter((group) => filters.groups?.split(',').includes(group.value))
    : [];

  const handleFilterChange = (filterKey: string, input: string) => {
    setParameters({ ...filters, [filterKey]: input });
  };

  const handleGroupsChange = (option: Option[]) => {
    handleFilterChange(queryParams.groups, [option.map((group) => group.value)].join(','));
  };

  return (
    <Box data-testid={'groups-selector'}>
      <MultiSelect
        className={classes.multiSelector}
        options={listData}
        value={filteredGroups}
        onChange={handleGroupsChange}
        labelledBy={'groups'}
        hasSelectAll={false}
        overrideStrings={{
          allItemsAreSelected: t('all_selected_label'),
          noOptions: t('no_groups_label'),
          search: t('search_by_name_label'),
          selectSomeItems: t('group_label'),
        }}
        ArrowRenderer={() => <BsFillCaretDownFill color={'var(--mantine-color-default-border)'} />}
      />
    </Box>
  );
};
